import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';
import React, { useEffect } from 'react';
import { Button } from 'reactstrap';
import * as firebase from 'firebase';

const storage = firebase.storage();

function Book_Delete_Step1({ deletedBook, notify, setBoookData, onClick, setEndIndex }) {
    console.log('my deleted book', deletedBook);

    const handleDelete = async () => {
        try {
            onClick();

            // Delete document from Firestore
            await db.collection('zSystemStore').doc(deletedBook.itemID).delete();

            // Delete book files (if URLs are valid)
            const deleteFile = async (fileUrl) => {
                if (!fileUrl) return;
                try {
                    const ref = fileUrl.startsWith('https://')
                        ? storage.refFromURL(fileUrl)
                        : storage.ref(fileUrl);
                    await ref.delete();
                    console.log(`${fileUrl} deleted successfully.`);
                } catch (error) {
                    console.error(`Failed to delete ${fileUrl}:`, error);
                }
            };

            await Promise.all([
                deleteFile(deletedBook.bookFileUrl),
                deleteFile(deletedBook.bookFileUrlMobile),
                deleteFile(deletedBook.bookcover),
            ]);

            notify('Book deleted successfully', false);
            setBoookData((prev) => prev.filter((item) => item.itemID !== deletedBook.itemID));
            setEndIndex((prev) => prev - 1);
        } catch (error) {
            notify(error.toString(), true);
        }
    };

    return (
        <div>
            <p>Do you want to delete this book?</p>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Button color="info" onClick={handleDelete}>Yes</Button>
                <Button onClick={onClick}>No</Button>
            </div>
        </div>
    );
}

export default Book_Delete_Step1;
